import { render } from "./LegalPage.vue?vue&type=template&id=361eb5fe&scoped=true"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"

import "./LegalPage.vue?vue&type=style&index=0&id=361eb5fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361eb5fe"]])

export default __exports__